// extracted by mini-css-extract-plugin
export default {"editLink":"edit_link___editLink___fb363099"};